module.exports = __webpack_public_path__ + "img/组 7472.87458561.png";